import i18next from 'i18next';

const availableFilters = [
  { label: i18next.t('Free', { ns: 'trackmanEvents' }), value: false, key: 'premiumEvent' },
  { label: i18next.t('Premium', { ns: 'trackmanEvents' }), value: true, key: 'premiumEvent' },
  { label: i18next.t('InPerson', { ns: 'trackmanEvents' }), value: 'InPerson', key: 'locationType' },
  { label: i18next.t('Online', { ns: 'trackmanEvents' }), value: 'Online', key: 'locationType' },
];

const filterSections = [{ key: 'premiumEvent', label: i18next.t('Subscription', { ns: 'trackmanEvents' }) }];

export const filtersConfig = filterSections.map((section) => ({
  label: section.label,
  options: availableFilters.filter((filter) => filter.key === section.key),
}));
